import { DateTime } from 'luxon'

export const WEDDING_DATE = DateTime.fromISO('2023-03-04T15:30:00-03:00', {
	setZone: true,
})
export const WEDDING_DATE_END = WEDDING_DATE.plus({ hours: 8 })

export const BREAKPOINTS = {
	sm: '576px',
	md: '768px',
	lg: '992px',
	xl: '1200px',
	xxl: '1400px',
}
